
Checkout.Payment.StoredCreditCard = function(checkout, payment, storedPayment) {
    var _scc = this;

    var $wrap;
	this.noDisplayCombo = ['paypal']; // don't even display the add-multi option

    var storedPaymentID = false;
    var storedPaymentType = 'creditcard';

    var init = function() {

        if (storedPayment) {
            storedPaymentID = storedPayment.method.split('-')[1];
            storedPaymentType = storedPayment.method.split('-')[0];
        }

        if (!storedPaymentID) {
            _scc.addError = 'Failed to retrieve Stored Credit Card info';
        }

        // [PS-507]
        // Do not allow stored card to be used more than once on the order
        if ( jQuery.grep(checkout.payment.getData(), function( scc ) { return scc.method == storedPayment.method; }).length > 0 ) {
        	if (storedPayment.cardType == 'btpaypal') 
        		_scc.addError = 'PayPal Account for ' + storedPayment.paypalEmail + ' already added';
            else
        		_scc.addError = creditCardTypes[storedPayment.cardType].label + ' ending in ' + storedPayment.cardLast4 + ' already added';
        	return;
        }
        
        if (getContainer().children().length == 6) {
            _scc.addError = 'Maximum of 6 Credit Card / PayPal Accounts Allowed';
            return;
        }

        buildContent();
        publish();
    };

    var publish = function() {
        _scc.$wrap = $wrap;
        _scc.label = 'Credit Card';
        _scc.getContainer = getContainer;
        _scc.afterRemoved = afterRemoved;
        _scc.getStoredPaymentID = getStoredPaymentID;
        _scc.getStoredPaymentType = getStoredPaymentType;
        _scc.getData = getData;
    };

    var buildContent = function() {

        $wrap = $('#payment-method-storedcreditcard-tpl')
            .clone(true)
            .removeAttr('id');

        $wrap.find('.select-cardtype')
            .val(storedPayment.cardType);

        $wrap.find('.card-number')
            .html('XXXX-XXXX-XXXX-'+storedPayment.cardLast4);

        if (storedPayment.paypalEmail) 
           $wrap.find('.paypal-email')
             .html( storedPayment.paypalEmail );

        var zeroPadMonth = '';
        if ((storedPayment.expMonth + '').length == 1)
            zeroPadMonth = '0';

        $wrap.find( ".expireMMYY" )
            .html( zeroPadMonth + storedPayment.expMonth + "/" + storedPayment.expYear );

        $wrap.find('.cvc')
            .html('XXX');

        $wrap.find('.credit-card').attr('class', (
            'payment-method-wrap clearfix credit-card '
            + storedPayment.cardType
            + ' gr-' + storedPayment.cardType
        ));

        var cardType = creditCardTypes[storedPayment.cardType] || {};
        if ( !creditCardTypes[ storedPayment.cardType] && creditCardTypes.cardType == 'btpaypal')
           cardType = {
               logo: "PayPal",
               watermark: "PayPal",
           };

        $wrap.find('.logo').html(cardType.logo);
        $wrap.find('.watermark').html(cardType.watermark);

    }

    var getContainer = function() {
        if (!payment.creditCardWrap)
            payment.creditCardWrap = new Checkout.Payment.CreditCardWrap(checkout, payment);

        return payment.creditCardWrap.$container;
    };

    var afterRemoved = function() {
        if (!getContainer().children().length) {
            payment.creditCardWrap.remove();
            payment.creditCardWrap = false;
        }
    };

    var getStoredPaymentID = function() {
        return storedPaymentID;
    }

    var getStoredPaymentType = function() {
        return storedPaymentType;
    }

    var getData = function() {
        return {
            'storedPaymentID': storedPaymentID,
            'storedPaymentType': storedPaymentType,
        };
    };

    init();
};

